import { createReducer, on } from "@ngrx/store";

import { initialRuleState } from "@app/project/store/clarehome.state";
import { LoadingState } from "@app/root-store/api-result.state";
import { RuleActions } from "../actions";
import { CHRuleState } from "../rule.state";

export const ruleReducer = createReducer(
    initialRuleState(),
    on(
        RuleActions.loadSet.request,
        (state, { uuid }): CHRuleState => ({
            ...state,
            uuid,
            callState: LoadingState.loading,
        })
    ),
    on(
        RuleActions.loadSet.success,
        (state, { rules }): CHRuleState => ({
            ...state,
            result: rules,
            callState: LoadingState.loaded,
        })
    ),
    on(
        RuleActions.loadSet.failure,
        (state, { error }): CHRuleState => ({
            ...state,
            result: null,
            error,
            callState: LoadingState.loaded,
        })
    ),
    on(RuleActions.deleteSet.success, (state, { rule }): CHRuleState => {
        const rules = { ...state.result };
        delete rules[rule.ruleId];
        return {
            ...state,
            result: rules,
            callState: LoadingState.loaded,
        };
    }),
    on(
        RuleActions.clearRuleState,
        (): CHRuleState => ({
            ...initialRuleState(),
        })
    )
);
